import { showAlert } from '../actions/miscellaneousActions';
import { IFileProps, IURLProps } from '../components/Modules/FileInputComponent';
import { IQuestion } from '../components/Modules/QuestionsTable';
import { del, get, post, put } from '../HTTP';
import { IHistory } from '../interfaces';
import { asyncForEach, base64ToFile, getBase64, getCurrentUserUUID, uploadDocsToS3, getBase64BIT, getBase64ForPrint } from '../utils/generalUtils';
import { ModuleModel } from '../model/ModuleModel';
import { IMCQFormInstance } from '../components/Modules/MCQPage';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import { getUserData } from './utilityServices';
import { logoImage } from './logoImage';
import { LibraryModuleModel } from 'src/model/LibraryModel';
import html2canvas from "html2canvas";
import QRCode from "qrcode";
import { UserModel } from 'src/model/UserModel';
import { getUsersByLevel } from './userService';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Loader } from '../components/reusableComponents/Loader/Loader';
import { fireConfettiFromPopup } from '../utils/confettiUtils';

const brandLogo = require('../images/LMS_eConnect_Crop.jpg');

const uuidv1 = require('uuid/v1');



export async function saveModules(moduleName: string, moduleDesc: string, MinimumMarksToPass: string, category: string, subCategory: string, TrainingDuration: any, files: IFileProps[], urls: IURLProps[], questions: IQuestion[], history: IHistory, moduleType: string = "Training Module", instructions: string = "") {
    try {
        const Links = [];
        await asyncForEach(files, async (fileData) => {
            const extension = fileData.fileName.split('.')[1];
            const newFile = new File([fileData.file], `${uuidv1()}.${extension}`);
            // const s3object = await uploadDocsToS3(newFile, 'demo');
            const base64BITImg = await getBase64BIT(fileData.file);
            Links.push({
                Link: base64BITImg,
                Title: fileData.fileName
            });
        });
        urls.forEach(urlData => {
            Links.push({
                Link: urlData.link,
                Title: urlData.title
            });
        });
        const Questions = questions.map((questionData, index) => {
            return {
                QuestionsNum: index + 1,
                Question: questionData.question,
                CorrectAnswer: questionData.CorrectAnswer,
                Choices: questionData.Choices
            };
        });

        const data = {
            Name: moduleName,
            Description: moduleDesc,
            MinimumMarksToPass: MinimumMarksToPass,
            TrainingDuration: TrainingDuration,
            Category: category,
            SubCategory: subCategory,
            UserId: getCurrentUserUUID(),
            Links,
            Questions,
            ModuleType: moduleType,
            Instructions: instructions
        };
        const response = await post('/Modules', data);
        showAlert({
            title: 'Success...!!',
            text: `${moduleName} Created.`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw error;
    }
}

export async function getAllModules(userId = '') {
    try {
        const userData = getUserData();
        const category = userData.category || 'all';
        ModuleModel.deleteAllInstances();
        let response = null;
        if (!userId) {
            response = await get(`/GetModules/${category}`, {});
        } else {
            ModuleModel.deleteAllInstances();
            response = await get(`/GetUserModule/${userId}/${category}`, {});
        }
        ((response.data.Modules ? response.data.Modules :
            (response.data instanceof Array ? response.data : [])) || []).forEach(instance => {
                if (!userId) {
                    instance.id = instance.ModuleID;
                    instance.Category = instance.Category;
                    instance.Completed = instance.Completed > 0;
                } else {
                    instance.id = instance.ModuleId;
                    instance.Name = instance.ModuleName;
                    instance.Category = instance.Category;
                }
                new ModuleModel(instance).$save();
            });
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}

export async function getModuleDetails(moduleID: string, userID?: string) {
    try {
        ModuleModel.deleteAllInstances();
        const response =
            await get(`/GetOneModule/${moduleID}/${getCurrentUserUUID() ? getCurrentUserUUID() : userID}`, {});
        const instance = response.data;
        instance.id = moduleID;
        new ModuleModel(instance).$save();
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}
export async function getCategoryDetails() {
    try {
        const loggedInUserData = getUserData();
        let OrganizationId = '';
        OrganizationId = loggedInUserData.Organization;
        // const response = await get(`/Category/${OrganizationId}`, {});
        const response = await get(`/Category`, {});
        const instance = response.data;

        return [instance.Category, instance.SubCategory];
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}
export async function RequestLibraryModules(moduleId, moduleName) {
    try {
        const loggedInUserData = getUserData();
        let OrganizationId = '';
        const UserId = getCurrentUserUUID();
        OrganizationId = loggedInUserData.Organization;
        if (moduleId) {

            const data = {
                CompanyId: getUserData().Organization,
                ModuleId: moduleId,
                UserId: getUserData().userUID,
                Status: '0',
                ModuleName: moduleName
            };
            const response = await post('/SaveLibraryModule', data);

            // const response = await post(`/SaveLibraryModules/${UserId}`, LibraryModules);
            // const instance = response.data;

            showAlert({
                title: 'Success...!!',
                text: 'Library Modules Requested.',
                type: 'success',
                closeOnConfirm: true,
                // confirmCallback: () => {
                //     history.push('/');
                // }
            }, 'submission', 5000);
            // history.push('/training/list');
            // await getAllModules('');
        } else {
            showAlert({
                title: 'Invalid...!!',
                text: 'Please Select Module For Adding.',
                type: 'invalid',
                closeOnConfirm: true,
                // confirmCallback: () => {
                //     history.push('/');
                // }
            }, 'submission');
        }
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw error;
    }
}
export async function saveLibraryModules(LibraryModules, history: IHistory) {
    try {
        const loggedInUserData = getUserData();
        let OrganizationId = '';
        const UserId = getCurrentUserUUID();
        OrganizationId = loggedInUserData.Organization;
        // if ( LibraryModules.length() > 0 ) {
        const response = await post(`/SaveLibraryModules/${UserId}`, LibraryModules);
        const instance = response.data;

        showAlert({
            title: 'Success...!!',
            text: 'Library Modules Added.',
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/libraryrequest');
            }
        }, 'submission', 5000);
        // history.push('/training/list');
        // await getAllModules('');
        // } else {
        //     showAlert({
        //         title: 'Invalid...!!',
        //         text:  'Please Select Module For Adding.',
        //         type: 'invalid',
        //         closeOnConfirm: true,
        //         // confirmCallback: () => {
        //         //     history.push('/');
        //         // }
        //     }, 'submission');
        // }
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw error;
    }
}
export async function getLibraryModules() {
    try {
        let userId = '';
        const userData = getUserData();
        const category = userData.category || 'all';
        let response = null;
        response = await get(`/LibraryModules/${category}`, {});
        return response.data;
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}
export async function postLibraryRequest(uniqueId, moduleId, status, history, instances) {
    try {
        let userId = '';
        const userData = getUserData();
        // LibraryModuleModel.deleteAllInstances();
        const LibraryModuleModels = LibraryModuleModel.listAll().reverse();
        const category = userData.category || 'all';
        const userID = userData.userUID
        let SelArrays = [];
        let SelModuleName = '';
        let SelUserId = '';
        for (let i = 0; i < LibraryModuleModels.length; i++) {
            SelArrays.push(LibraryModuleModels[i].props);
            if (SelArrays[i].ModuleID === moduleId) {
                SelModuleName = SelArrays[i].Name;
                SelUserId = SelArrays[i].RequestUserId;
            }
        }
        const data = {
            UniqueId: uniqueId,
            ModuleId: moduleId,
            UserId: getCurrentUserUUID(),
            RequestUserId: SelUserId,
            ModuleName: SelModuleName,
            Status: status
        };
        let response = null;
        let getresponse = null;
        response = await put(`/UpdateLibraryStatus`, data);

        if (status === '1' && response.Message === 'Post Successfully') {
            // Find the correct module to pass to saveLibraryModules
            const matchedModule = LibraryModuleModels.find(m => (m.props as any).ModuleID === moduleId);
            if (matchedModule) {
                await saveLibraryModules(matchedModule.props, history);
            }
        }
        
        await getRequestedModules('');

        showAlert({
            title: 'Success...!!',
            text: 'Library Modules Request Updated.',
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/libraryrequest');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}
export async function getRequestedModules(userId = '') {
    try {
        let response = null;
        let responses = null;

        const userData = getUserData();
        const category = userData.category || 'all';
        response = await get(`/GetRequestedModules/${category}`, {});
        (response.data ? response.data : []).forEach((instance, index) => {
            instance.id = `${index + 1}`;
            // instance.userName = instance.UserName || instance.Name;
            instance.requestDate = instance.RequestedDate;
            instance.organizationName = instance.OrganizationName;
            instance.moduleName = instance.Name;
            instance.status = instance.Status;
            instance.category = instance.Category;
            instance.moduleId = instance.ModuleID;
            instance.uniqueId = instance.id;
            instance.requestId = instance.RequestId
            new LibraryModuleModel(instance).$save();
        });

    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}
// const getBase64BIT = file => {
//     return new Promise((resolve, reject) => {
//         const fileReader = new FileReader();
//         fileReader.readAsDataURL(file);
//         fileReader.onload = () => {
//           resolve(fileReader.result);
//         };
//         fileReader.onerror = (error) => {
//           reject(error);
//         };
//       });
//   };
export async function updateModule(moduleName: string, moduleDesc: string, minMarkToPass: string, TrainingDuration: number, files: IFileProps[], urls: IURLProps[], category: string, subCategory: string,
    questions: IQuestion[], history: IHistory, moduleID: string, moduleType: string = "Training Module", instructions: string = "") {
    try {
        const Links = [];
        await asyncForEach(files, async (fileData) => {
            const extension = fileData.fileName.split('.')[1];
            const newFile = new File([fileData.file], `${uuidv1()}.${extension}`);
            const base64BITImg = await getBase64BIT(fileData.file);

            // const s3object = await uploadDocsToS3(newFile, 'demo');
            // Links.push({
            //     Link: s3object,
            //     Title: fileData.fileName
            // });

            Links.push({
                Link: base64BITImg,
                Title: fileData.fileName
            });
        });
        urls.forEach(urlData => {
            Links.push({
                Link: urlData.link,
                Title: urlData.title
            });
        });
        const Questions = questions.map((questionData, index) => {
            return {
                QuestionsNum: index + 1,
                Question: questionData.question,
                CorrectAnswer: questionData.CorrectAnswer,
                Choices: questionData.Choices
            };
        });
        const data = {
            Name: moduleName,
            Description: moduleDesc,
            UserId: getCurrentUserUUID(),
            Links,
            Questions,
            TrainingDuration,
            MinimumMarksToPass: minMarkToPass,
            Category: category,
            SubCategory: subCategory,
            ModuleType: moduleType,
            Instructions: instructions
        };
        const response = await put(`/UpdateModule/${moduleID}`, data);
        showAlert({
            title: 'Success...!!',
            text: `${moduleName} Updated.`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw error;
    }
}

export async function deleteModule(moduleIDs: string[], moduleName: string, history?: IHistory) {
    try {
        const response = await del('/DeleteModules', { Modules: moduleIDs });
        ModuleModel.deleteAllInstances();
        showAlert({
            title: 'Success...!!',
            text: `${moduleName} Deleted.`,
            type: 'success',
            closeOnConfirm: true
        }, 'submission', 5000);
        history.push('/training/list');
        await getAllModules();
    } catch (error) {
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            closeOnConfirm: true
        },
            'submission');
        throw new Error(error);
    }
}

export async function submitTest(data: IMCQFormInstance, history: IHistory, userName: string, trainingName: string, continueLater: boolean, isInstruction: boolean = false) {
    const submissionData = {
        UserId: data.UserId,
        ModuleId: data.ModuleId,
        continueLater: continueLater,
        userName: userName,
        moduleName: trainingName,
        userEmail: getUserData().Email || getUserData().email || '',
        orgName: getUserData().OrganizationName || getUserData().CompanyName || '',
        Answers: (data.Answers || []).map(ansData => {
            return { QueNum: ansData.QueNum, Answer: ansData.Answer };
        })
    };
    try {
        const response = await put('/Test', submissionData);
        if (response.Message === 'Fail' || response.Message === 'fail') {
            showAlert({
                title: 'Oops..!!!',
                text: 'You have failed on this test. Try going through the Documents again...!',
                allowEscapeKey: false,
                allowOutsideClick: false,
                imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Frowny.svg/600px-Frowny.svg.png',
                closeOnConfirm: true,
                confirmCallback: () => {
                    history.push('/');
                }
            },
                'submission');
        } else if (response.Message === 'Pass' || response.Message === 'pass') {
            const titleText = isInstruction ? 'Success' : 'Yippie!!';
            const messageText = isInstruction 
                ? 'Instruction marked as complete.' 
                : 'You just passed the test..!!! Congrats';
            
            /* tslint:disable */
            showAlert({
                title: titleText,
                text: messageText,
                imageUrl: 'https://cdn.shopify.com/s/files/1/1061/1924/products/Thumbs_Up_Hand_Sign_Emoji_large.png?v=1480481047',
                confirmButtonText: 'Get Your Certificate',
                allowEscapeKey: false,
                allowOutsideClick: false,
                closeOnConfirm: true,
                confirmCallback: async () => {
                    const loaderContainer = document.createElement('div');
                    loaderContainer.id = 'certificate-loader';
                    loaderContainer.style.cssText = `
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        z-index: 99999;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: rgba(0, 0, 0, 0.5);
                    `;
                    document.body.appendChild(loaderContainer);
                    
                    const loaderElement = document.createElement('div');
                    loaderElement.id = 'loader-content';
                    loaderContainer.appendChild(loaderElement);
                    
                    ReactDOM.render(
                        React.createElement(Loader, { type: "async" }),
                        loaderElement
                    );
                    // ============================================================
                    //  DATA PREPARE 
                    // ============================================================
                    const today = new Date();
                    let dd = String(today.getDate()).padStart(2, '0');
                    let mm = String(today.getMonth() + 1).padStart(2, '0');
                    const yyyy = today.getFullYear();
                    const date = mm + '/' + dd + '/' + yyyy;

                    //  Certificate Number
                    const certNo = `LMS-ENV-${yyyy}-${String(Math.floor(Math.random() * 10000)).padStart(4, '0')}`;
                    const safeTrainingName = trainingName.replace(/[^a-zA-Z0-9]/g, '_');
                    const fileName = `${safeTrainingName}_${certNo}`;

                    const loggedInUserData = getUserData();
                    const userInstance = UserModel.get(loggedInUserData.userUID);
                    const currentUserAccessLevel = userInstance?.props?.AccessLevel || userInstance?.props?.Access_Level || '';
                    const currentUserOrg = userInstance?.props?.Organization ||
                        userInstance?.props?.Company || '';

                    let directorName = '';

                    // ============================================================
                    //  FOR L3 USER  - getUsersByLevel() function 
                    // ============================================================
                    if (currentUserAccessLevel === 'L3') {
                        try {
                            const response = await getUsersByLevel();

                            //  Handle both response structures
                            const l2User = response?.data || response;

                            directorName = l2User
                                ? `${l2User.FirstName || ''} ${l2User.LastName || ''}`.trim()
                                : '';
                        } catch (error) {
                            console.error("Failed to fetch L2 user:", error);
                            directorName = '';
                        }
                    } else {

                        const allUsers = UserModel.list();
                        const programDirector = allUsers.find(user => {
                            const accessLevel = user.props.AccessLevel || user.props.Access_Level || '';
                            const userOrg = user.props.Organization || user.props.Company || '';
                            return accessLevel === 'L2' && userOrg === currentUserOrg;
                        });

                        const finalDirector = programDirector || allUsers.find(user => {
                            const accessLevel = user.props.AccessLevel || user.props.Access_Level || '';
                            return accessLevel === 'L2';
                        });

                        directorName = finalDirector
                            ? `${finalDirector.props.FirstName || ''} ${finalDirector.props.LastName || ''}`.trim()
                            : '';
                    }


                    const certLink = `https://elms-training.s3.amazonaws.com/certificates/${certNo}.pdf`;

                    await generateCertificateFromHTML({
                        NAME: userName,
                        COURSE: trainingName,
                        EXAM: trainingName,
                        CERTIFICATE: fileName,
                        CERTIFICATE_NO: certNo,
                        DATE: date,
                        PROGRAM_DIRECTOR: directorName || '',
                        CERTIFICATE_LINK: certLink,
                        USER_UUID: data.UserId,
                        MODULE_ID: data.ModuleId,
                        MODULE_TYPE_PROGRAM: isInstruction ? 'Instruction Program' : 'Training Program'
                    });
                    ReactDOM.unmountComponentAtNode(loaderElement);
                    document.body.removeChild(loaderContainer);

                    history.push('/home');
                }
            }, 'submission');
            setTimeout(() => {
    const popup = document.querySelector('.sweet-alert') as HTMLElement || 
                  document.querySelector('.swal2-popup') as HTMLElement;
    
    if (popup) {
      fireConfettiFromPopup(popup, {
        count: 90,        
        duration: 3500,   
        colors: ['#ff4081', '#00bcd4', '#4caf50', '#ffeb3b', '#ff9800', '#9c27b0']
      });
    }
  }, 200);
        } else if (response.Message === 'No Data') {
            showAlert({
                title: 'Oops..!!',
                text: response.Message,
                type: 'error',
                allowEscapeKey: false,
                allowOutsideClick: false,
                closeOnConfirm: true,
                confirmCallback: () => {
                    history.push('/');
                }
            },
                'submission');
            //await getCertificate(userName, data.UserId, trainingName, history);
        } else if (response.Message === 'Answers Saved') {
            showAlert({
                title: 'Okay..!!',
                text: 'You can do this on later..!',
                allowEscapeKey: false,
                allowOutsideClick: false,
                closeOnConfirm: true,
                confirmCallback: () => {
                    history.push('/');
                }
            },
                'submission');
        } else {
            showAlert({
                title: 'Oops..!!',
                text: response.Message,
                type: 'error',
                allowEscapeKey: false,
                allowOutsideClick: false,
                closeOnConfirm: true,
                confirmCallback: () => {
                    history.push('/');
                }
            },
                'submission');
        }
    } catch (error) {
        const loaderElement = document.getElementById('loader-content');
        const loaderContainer = document.getElementById('certificate-loader');
        if (loaderElement) {
            ReactDOM.unmountComponentAtNode(loaderElement);
        }
        if (loaderContainer) {
            document.body.removeChild(loaderContainer);
        }
        showAlert({
            title: 'Oops..!!',
            text: error,
            type: 'error',
            allowEscapeKey: false,
            allowOutsideClick: false,
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        },
            'submission');
        throw new Error(error);

    }
}

// async function getCertificate(userName: string, userUUID: string, trainingName: string, history: IHistory,moduleID: string) {

//     const {vfs} = vfsFonts.pdfMake;
//     pdfMake.vfs = vfs;
//     const today = new Date();
//     const loggedInUserData = getUserData();
//     const orgUrlToImage = await getBase64ForPrint(loggedInUserData.LogoURL);
//     const companyLogo = `data:image/png;base64,${orgUrlToImage}`;  
//     const base64 = companyLogo;
//     let dd = today.getDate().toString();
//     let mm = (today.getMonth() + 1).toString();
//     const yyyy = today.getFullYear();
//     if (Number(dd) < 10) {
//         dd = '0' + dd;
//     }
//     if (Number(mm) < 10) {
//         mm = '0' + mm;
//     }
//     const date = mm + '/' + dd + '/' + yyyy;
//     const docDefinition = {
//   pageSize: 'A4',
//   pageOrientation: 'landscape',
//   pageMargins: [0, 0, 0, 0],

//   background: function () {
//     return {
//       canvas: [
//         // Outer border - Dark Green 
//         { type: 'rect', x: 14, y: 14, w: 813, h: 567, r: 12, lineWidth: 3, color: '#0d4a1e' },
//         // Inner thin border - Gold 
//         { type: 'rect', x: 24, y: 24, w: 793, h: 547, r: 8, lineWidth: 1.5, color: '#e0e0e0' },
//         // Corner accents (top-left) - Gold
//         { type: 'line', x1: 24, y1: 55, x2: 24, y2: 24, lineWidth: 3, color: '#e0e0e0' },
//         { type: 'line', x1: 24, y1: 24, x2: 55, y2: 24, lineWidth: 3, color: '#e0e0e0' },
//         // Corner accents (top-right) - Gold
//         { type: 'line', x1: 817 - 55, y1: 24, x2: 817, y2: 24, lineWidth: 3, color: '#e0e0e0' },
//         { type: 'line', x1: 817, y1: 24, x2: 817, y2: 55, lineWidth: 3, color: '#e0e0e0' },
//         // Corner accents (bottom-left) - Gold
//         { type: 'line', x1: 24, y1: 571 - 31, x2: 24, y2: 571, lineWidth: 3, color: '#e0e0e0' },
//         { type: 'line', x1: 24, y1: 571, x2: 55, y2: 571, lineWidth: 3, color: '#e0e0e0' },
//         // Corner accents (bottom-right) - Gold
//         { type: 'line', x1: 817 - 55, y1: 571, x2: 817, y2: 571, lineWidth: 3, color: '#e0e0e0' },
//         { type: 'line', x1: 817, y1: 571, x2: 817, y2: 571 - 31, lineWidth: 3, color: '#e0e0e0' }
//       ]
//     };
//   },

//   content: [
//     {
//       stack: [
//         // ===== TOP BAR: LOGOS + TITLE =====
//         {
//           columns: [
//             {
//               image: logoImage.logo,
//               width: 78,
//               height: 48,
//               alignment: 'left'
//             },
//             {
//               stack: [
//                 { 
//                   text: 'CERTIFICATE', 
//                   fontSize: 32, 
//                   bold: true, 
//                   color: '#0d4a1e',  // Dark Green - Premium look
//                   alignment: 'center', 
//                   characterSpacing: 8   //  increase for elegance
//                 },
//                 { 
//                   text: 'O F   A C H I E V E M E N T', 
//                   fontSize: 12, 
//                   color: '#b8922f',  // Dark Gold - Elegant
//                   alignment: 'center', 
//                   characterSpacing: 4, 
//                   margin: [0, 2, 0, 0] 
//                 }
//               ],
//               width: '*'
//             },
//             {
//               image: base64,
//               width: 78,
//               height: 48,
//               alignment: 'right'
//             }
//           ],
//           columnGap: 10,
//           margin: [50, 34, 50, 0]
//         },

//         // ===== GOLD DIVIDER =====
//         {
//           canvas: [
//             { type: 'line', x1: 280, y1: 0, x2: 537, y2: 0, lineWidth: 1.5, color: '#e0e0e0' },  
//             { type: 'ellipse', x: 408.5, y: 0, r1: 4, r2: 4, color: '#e0e0e0' }  
//           ],
//           margin: [0, 14, 0, 0]
//         },

//         // ===== CERTIFY TEXT =====
//         {
//           text: 'This is to proudly certify that',
//           fontSize: 16,
//           italics: true,
//           color: '#666666',  //  soft gray
//           alignment: 'center',
//           margin: [0, 18, 0, 6]
//         },

//         // ===== USER NAME =====
//         {
//           text: userName,
//           fontSize: 36,
//           bold: true,
//           color: '#0d4a1e',  // Dark Green match with title
//           alignment: 'center',
//           characterSpacing: 2,  
//           margin: [0, 0, 0, 10]
//         },

//         // ===== COMPLETION TEXT =====
//         {
//           text: 'has successfully completed the training program',
//           fontSize: 16,
//           color: '#666666',  // Soft gray
//           alignment: 'center',
//           margin: [0, 0, 0, 10]
//         },

//         // ===== MODULE / TRAINING NAME (pill/badge) =====
//         {
//         text: trainingName,
//         fontSize: 24,
//         bold: true,
//         color: '#0d4a1e',
//         alignment: 'center',
//         margin: [0, 8, 0, 22]  // <-- 
// },

//         // ===== AWARDED DATE =====
//         {
//           text: `Awarded: ${date}`,
//           fontSize: 18,
//           bold: true,
//           color: '#0d4a1e',  // Dark Green
//           alignment: 'center',
//           margin: [0, 10, 0, 10]
//         },
//       ]
//     }
//   ],

//   defaultStyle: {
//     font: 'Roboto'
//   }
// };
//     pdfMake.createPdf(docDefinition).getDataUrl(async (dataURL) => {
//         const uuid = uuidv1();
//         const linkName = trainingName.replace(/[^\w\s]/gi, '-');
//         const newFile = await base64ToFile(dataURL, linkName + '-' + uuid + '-Certificate.pdf');
//         // const s3object = await uploadDocsToS3(newFile, 'certificates');
//         const base64BITImg = await getBase64BIT(newFile);
//         const data = {
//             UniqueId: userUUID,
//             // CertificateLink: s3object.location,
//             // CertificateName: trainingName
//             CertificateLink: base64BITImg,
//             CertificateName: linkName + '-' + uuid + '-Certificate.pdf',
//             ModuleId : moduleID
//             // CertificateName: `TrainingModule ${userName.replace(/ /g, '')} Certificate.pdf`
//         };
//         try {
//             const response = await post('/AddCertificate', data);
//             await getAllModules(userUUID);
//             history.push('/home');
//             return response;
//         } catch (error) {
//             showAlert({
//                     title: 'Oops..!!',
//                     text: error,
//                     allowEscapeKey: false,
//                     allowOutsideClick: false,
//                     type: 'error',
//                     closeOnConfirm: true
//                 },
//                 'submission');
//             throw new Error(error);
//         }
//     });
//     pdfMake.createPdf(docDefinition).download(trainingName);
// }



export const generateCertificateFromHTML = async (data: any) => {
    try {
        const loggedInUserData = getUserData();
        const orgUrlToImage = await getBase64ForPrint(loggedInUserData.LogoURL);
        const rightLogo = `data:image/png;base64,${orgUrlToImage}`;
        const leftLogo = logoImage.logo;

        // ============================================================
        //  STEP 1: CERTIFICATE NAME 
        // ============================================================
        const trainingName = data.COURSE || data.NAME || 'Certificate';
        const certNo = data.CERTIFICATE_NO || 'Certificate';
        const uuid = uuidv1();

        const finalCertName = `${trainingName.replace(/[^a-zA-Z0-9]/g, '_')}-${uuid}-Certificate.pdf`;

        // ============================================================
        //  STEP 2: QR CODE GENERATE 
        // ============================================================

        const tempLink = `https://elms-training.s3.amazonaws.com/certificates/${finalCertName}`;

        const qrCodeDataUrl = await QRCode.toDataURL(tempLink, {
            width: 150,
            height: 150,
            margin: 2,
            color: {
                dark: '#1b5e20',
                light: '#ffffff'
            }
        });

        // ============================================================
        //  STEP 3: HTML LOAD AND REPLACE
        // ============================================================
        const response = await fetch("/elms  certificate.html");

        if (!response.ok) {
            throw new Error(`Failed to load HTML: ${response.status}`);
        }

        let html = await response.text();

        html = html.replace(/{{LEFT_LOGO}}/g, leftLogo);
        html = html.replace(/{{RIGHT_LOGO}}/g, rightLogo);

        // QR CODE INSERT 
        if (html.includes('class="qr"')) {
            html = html.replace(
                /<div class="qr">[\s\S]*?<\/div>/,
                `<div class="qr">
                    <img src="${qrCodeDataUrl}" alt="QR Code" style="width:90px;height:90px;object-fit:contain;">
                </div>`
            );
        } else {
            html = html.replace(
                '</div>',
                `<div class="qr">
                    <img src="${qrCodeDataUrl}" alt="QR Code" style="width:90px;height:90px;object-fit:contain;">
                </div></div>`
            );
        }

        // DATA REPLACE 
        Object.keys(data).forEach(key => {
            if (key === 'CERTIFICATE_LINK') return;
            html = html.replace(
                new RegExp(`{{${key}}}`, "g"),
                data[key] || ""
            );
        });

        // ============================================================
        //  STEP 4: HTML TO CANVAS
        // ============================================================
        const wrapper = document.createElement("div");
        wrapper.style.position = "absolute";
        wrapper.style.left = "0";
        wrapper.style.top = "0";
        wrapper.style.width = "1123px";
        wrapper.style.height = "794px";
        wrapper.style.background = "#ffffff";
        wrapper.style.zIndex = "9999";
        wrapper.style.opacity = "0";
        wrapper.style.pointerEvents = "none";
        wrapper.innerHTML = html;
        document.body.appendChild(wrapper);

        await new Promise(resolve => setTimeout(resolve, 1000));

        const images = wrapper.querySelectorAll("img");
        await Promise.all(
            Array.from(images).map((img: HTMLImageElement) => {
                if (img.complete) return Promise.resolve();
                return new Promise((resolve) => {
                    img.onload = resolve;
                    img.onerror = resolve;
                });
            })
        );

        await new Promise(resolve => setTimeout(resolve, 500));

        const certificateElement = wrapper.querySelector('.certificate') as HTMLElement;

        if (!certificateElement) {
            throw new Error("Certificate element not found");
        }

        const canvas = await html2canvas(certificateElement, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff",
            logging: true,
            allowTaint: true,
            width: 1123,
            height: 794,
            onclone: (clonedDoc: Document) => {
                const el = clonedDoc.querySelector('.certificate');
                if (el) {
                    (el as HTMLElement).style.visibility = 'visible';
                    (el as HTMLElement).style.display = 'block';
                    (el as HTMLElement).style.opacity = '1';
                }
            }
        });

        document.body.removeChild(wrapper);

        const image = canvas.toDataURL("image/png");

        // ============================================================
        //  STEP 5: PDF DEFINITION
        // ============================================================
        const docDefinition = {
            pageSize: "A4",
            pageOrientation: "landscape",
            pageMargins: [0, 0, 0, 0],
            content: [
                {
                    image: image,
                    width: 842,
                    height: 595,
                    alignment: 'center'
                }
            ]
        };

        // ============================================================
        //  STEP 6: PDF GENERATE 
        // ============================================================
        pdfMake.createPdf(docDefinition).getDataUrl(async (dataURL) => {

            //  BASE64 TO FILE 
            const newFile = await base64ToFile(dataURL, finalCertName);

            //  BASE64 CONVERT 
            const base64BITImg = await getBase64BIT(newFile);

            // ============================================================
            //  STEP 7: SAVE IN BACKEND 
            // ============================================================
            const saveData = {
                UniqueId: data.USER_UUID || getCurrentUserUUID(),
                CertificateLink: base64BITImg,
                CertificateName: finalCertName,
                ModuleId: data.MODULE_ID || ''
            };

            try {
                const response = await post('/AddCertificate', saveData);

                // ============================================================
                //   STEP 8: USE BACKEND ACTUAL S3 LINK AND UPDATE IT
                // ============================================================
                if (response && response.CertificateLink) {
                    const actualS3Link = response.CertificateLink;


                }

                await getAllModules(data.USER_UUID || getCurrentUserUUID());

                return response;
            } catch (error) {
                console.error(error);
                showAlert({
                    title: 'Oops..!!',
                    text: (error as Error)?.message || 'Failed to save certificate',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    type: 'error',
                    closeOnConfirm: true
                }, 'submission');
                throw new Error(error as string);
            }
        });

        // ============================================================
        //  STEP 9: DOWNLOAD PDF 
        // ============================================================
        pdfMake.createPdf(docDefinition).download(finalCertName);

    } catch (err) {
        console.error("PDF Generation Error:", err);
        throw err;
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/moduleService.ts